import { pipe } from 'rxjs';
import { selectClicks } from './clicks.selector';

export const selectIsTravelling = pipe(selectClicks, (clicks) => clicks > 0);
